/** 중점과제 Category (목표 유형) — 정량/정성과 별개 */
export const TASK_CATEGORIES = [
  { value: 'CORE', label: '핵심성과' },
  { value: 'SUPPORT', label: '지원/운영' },
  { value: 'PROJECT', label: '프로젝트' },
] as const;

export type TaskCategory = (typeof TASK_CATEGORIES)[number]['value'];

/** Calibration·절대평가 비교를 위한 평가군 */
export const EVAL_GROUPS = [
  { value: '', label: '미지정' },
  { value: 'GROUP_A', label: '평가군 A' },
  { value: 'GROUP_B', label: '평가군 B' },
  { value: 'GROUP_C', label: '평가군 C' },
] as const;

export function taskCategoryLabel(value?: string): string {
  return TASK_CATEGORIES.find((c) => c.value === value)?.label || value || '미분류';
}

export function evalGroupLabel(value?: string): string {
  if (!value) return '미지정';
  return EVAL_GROUPS.find((g) => g.value === value)?.label || value;
}

/** 피평가자의 승인된 과제에서 지정된 협업 동료 ID 수집 */
export function coworkerIdsFromTasks(
  subjectId: string,
  tasks: Array<{ ownerId?: string; status?: string; coworkerIds?: string[] }>
): string[] {
  const ids = new Set<string>();
  tasks.forEach((t) => {
    if (t.ownerId !== subjectId) return;
    if (t.status && t.status !== 'APPROVED' && t.status !== 'REGISTERED') return;
    (t.coworkerIds || []).forEach((id) => {
      if (id && id !== subjectId) ids.add(id);
    });
  });
  return Array.from(ids);
}

/**
 * 풀 추천: 협업 동료 우선, 부족하면 동일 부서 인원으로 보충 (최대 8명)
 */
export function recommendedPoolIds(
  subjectId: string,
  tasks: Array<{ ownerId?: string; status?: string; coworkerIds?: string[] }>,
  members: Array<{ id: string; department?: string }>
): string[] {
  const fromTasks = coworkerIdsFromTasks(subjectId, tasks);
  const subject = members.find((m) => m.id === subjectId);
  const sameDept = members
    .filter((m) => m.id !== subjectId && subject?.department && m.department === subject.department)
    .map((m) => m.id);

  const ordered: string[] = [];
  const seen = new Set<string>();
  [...fromTasks, ...sameDept].forEach((id) => {
    if (seen.has(id)) return;
    seen.add(id);
    ordered.push(id);
  });
  return ordered.slice(0, 8);
}

export function formatCoworkerNames(
  coworkerIds: string[] | undefined,
  membersById: Record<string, { name?: string }>,
  fallbackText?: string
): string {
  if (Array.isArray(coworkerIds) && coworkerIds.length > 0) {
    return coworkerIds.map((id) => membersById[id]?.name || id).join(', ');
  }
  return fallbackText || '없음';
}
